<template>
  <div class="modal fade" id="generateAllDatasetsModalForm" tabindex="-1" aria-labelledby="generateAllDatasetsModalFormLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="generateAllDatasetsModalFormLabel">Generate Datasets for All Students</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            <div class="alert alert-info" role="alert">
              <p class="mb-2">
                <strong>Note:</strong> Generating datasets for all students could take several hours.
              </p>
              <p class="mb-0">
                When generating datasets, pre-check and evaluation would wait and execute after generating is finished.
              </p>
            </div>
            
            <div class="mb-3">
              <label class="form-label">Generation Options:</label>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="regenerateOption" id="onlyMissing" 
                  value="false" v-model="regenerateAll">
                <label class="form-check-label" for="onlyMissing">
                  Generate only for students without datasets
                </label>
                <div class="form-text">Only creates datasets for students who don't have one yet.</div>
              </div>
              <div class="form-check">
                <input class="form-check-input" type="radio" name="regenerateOption" id="regenerateAll" 
                  value="true" v-model="regenerateAll">
                <label class="form-check-label" for="regenerateAll">
                  Regenerate for all students
                </label>
                <div class="form-text">Creates new datasets for all students, replacing existing ones.</div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-primary">Start Generation</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <StemErrorModal ref="stemErrorModal" />
</template>

<script>
import { Modal } from 'bootstrap';
import StemErrorModal from '@/components/StemErrorModal.vue';

export default {
  name: 'GenerateAllDatasetsModalForm',
  components: {
    StemErrorModal
  },
  data() {
    return {
      regenerateAll: 'false',
    };
  },
  mounted() {
    // Reset form when modal is hidden
    const modalElement = document.getElementById('generateAllDatasetsModalForm');
    modalElement.addEventListener('hidden.bs.modal', this.resetForm);
  },
  methods: {
    resetForm() {
      this.regenerateAll = 'false';
    },
    submitForm() {
      // Convert string to boolean and emit
      const shouldRegenerateAll = this.regenerateAll === 'true';
      
      // Manually hide the modal on success
      const modalElement = document.getElementById('generateAllDatasetsModalForm');
      const modalInstance = Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }

      this.$emit('submitForm', shouldRegenerateAll);
    }
  }
};
</script>
